var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography, Box } from '@mui/material';
import React from 'react';
import { memo } from "react";
import { ErrorIcon, WarningIcon, CheckCircleIcon, CloseFileCardIcon } from "../icons";
import '../../assets/scss/customAlert.scss';
import CachedIcon from '@mui/icons-material/Cached';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { openEmlAttachment } from '../../utils/emlAttachmentViewer';
var WARNING_ACTION_BUTTON_SX = {
    minWidth: 170,
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: 600,
};
var WARNING_FILLED_BUTTON_SX = __assign(__assign({}, WARNING_ACTION_BUTTON_SX), { border: '1px solid transparent' });
export var POPUP_TYPE = {
    UNSAVED_DATA_WARNING: 'UNSAVED_DATA_WARNING',
    DELETE_CONFIRMATION_WARNING: 'DELETE_CONFIRMATION_WARNING',
    SUCCESS_ALERT: 'SUCCESS_ALERT',
    EVENT_NOT_ALLOWED: 'EVENT_NOT_ALLOWED',
    LOGOUT_WARNING: 'LOGOUT_WARNING',
    RELOAD: 'RELOAD',
    BINARY_FILE_PREVIEW: 'BINARY_FILE_PREVIEW',
};
var ConfirmationAndInformationPoup = function (_a) {
    var popupType = _a.popupType, titleText = _a.titleText, subTitleText = _a.subTitleText, message = _a.message, acceptBtnText = _a.acceptBtnText, acceptCallBack = _a.acceptCallBack, denyBtnText = _a.denyBtnText, denyCallBack = _a.denyCallBack, cancelCallBack = _a.cancelCallBack, closePdf = _a.closePdf, open = _a.open, fileUrl = _a.fileUrl, _b = _a.previewType, previewType = _b === void 0 ? 'pdf' : _b, previewHtml = _a.previewHtml, attachments = _a.attachments, _c = _a.swapButtonOrder, swapButtonOrder = _c === void 0 ? false : _c, _d = _a.enablePreviewZoom, enablePreviewZoom = _d === void 0 ? false : _d, _e = _a.equalWidthActions, equalWidthActions = _e === void 0 ? false : _e;
    var DEFAULT_ZOOM_PERCENTAGE = 100;
    var MIN_ZOOM_PERCENTAGE = 50;
    var MAX_ZOOM_PERCENTAGE = 200;
    var ZOOM_STEP = 25;
    var _f = React.useState(DEFAULT_ZOOM_PERCENTAGE), zoomPercentage = _f[0], setZoomPercentage = _f[1];
    var zoomScale = zoomPercentage / 100;
    React.useEffect(function () {
        setZoomPercentage(DEFAULT_ZOOM_PERCENTAGE);
    }, [open, fileUrl, previewType, previewHtml, titleText]);
    var setClampedZoom = React.useCallback(function (nextZoom) {
        setZoomPercentage(Math.min(MAX_ZOOM_PERCENTAGE, Math.max(MIN_ZOOM_PERCENTAGE, nextZoom)));
    }, []);
    var handleZoomOut = React.useCallback(function () {
        setClampedZoom(zoomPercentage - ZOOM_STEP);
    }, [setClampedZoom, zoomPercentage]);
    var handleZoomIn = React.useCallback(function () {
        setClampedZoom(zoomPercentage + ZOOM_STEP);
    }, [setClampedZoom, zoomPercentage]);
    var shouldShowZoom = popupType === POPUP_TYPE.BINARY_FILE_PREVIEW && enablePreviewZoom;
    var zoomedMinWidth = zoomPercentage > 100 ? "".concat(zoomPercentage, "%") : '100%';
    var getZoomStyles = React.useCallback(function (origin) {
        if (origin === void 0) { origin = 'top left'; }
        return ({
            transform: "scale(".concat(zoomScale, ")"),
            transformOrigin: origin,
        });
    }, [zoomScale]);
    switch (popupType) {
        case POPUP_TYPE.BINARY_FILE_PREVIEW: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow', sx: { '& .MuiPaper-root': {
                        minWidth: '60%',
                        '& .MuiDialogContent-root': {
                            padding: '0px !important'
                        },
                        '& .dialogue-title': {
                            paddingTop: '8px !important'
                        }
                    } } },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title' },
                    React.createElement(Box, { className: 'dialogue-text', display: 'flex', textAlign: 'center', justifyContent: 'space-between', alignItems: 'center', width: '100%' },
                        React.createElement(Box, { textAlign: 'center', width: '100%' },
                            React.createElement(Typography, null, titleText),
                            React.createElement(Typography, { fontSize: '12px !important' }, subTitleText)),
                        React.createElement(Box, { display: 'flex', alignItems: 'center', gap: 1 },
                            shouldShowZoom ? (React.createElement(React.Fragment, null,
                                React.createElement(IconButton, { size: "small", onClick: handleZoomOut, disabled: zoomPercentage <= MIN_ZOOM_PERCENTAGE, sx: {
                                        border: '1px solid #D1D5DB',
                                        borderRadius: '8px',
                                        color: '#111827',
                                    } },
                                    React.createElement(RemoveIcon, { fontSize: "small" })),
                                React.createElement(Box, { sx: {
                                        minWidth: 56,
                                        px: 1,
                                        py: 0.65,
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        backgroundColor: '#F3F4F6',
                                        color: '#111827',
                                        fontSize: 12,
                                        fontWeight: 700,
                                    } },
                                    zoomPercentage,
                                    "%"),
                                React.createElement(IconButton, { size: "small", onClick: handleZoomIn, disabled: zoomPercentage >= MAX_ZOOM_PERCENTAGE, sx: {
                                        border: '1px solid #D1D5DB',
                                        borderRadius: '8px',
                                        color: '#111827',
                                    } },
                                    React.createElement(AddIcon, { fontSize: "small" })))) : null,
                            React.createElement(IconButton, { onClick: function () { return closePdf && closePdf(); }, className: 'close-icon' },
                                " ",
                                React.createElement(CloseIcon, null))))),
                React.createElement(DialogContent, { sx: { paddingBottom: '24px !important' } },
                    React.createElement(DialogContentText, { id: "alert-dialog-description", sx: { padding: '0px 24px',
                            '& iframe': {
                                height: "calc(100dvh - 126px)"
                            },
                            '& .image-preview': {
                                maxHeight: 'calc(100dvh - 180px)',
                                width: '100%',
                                objectFit: 'contain',
                                display: 'block',
                            },
                            '& .doc-preview': {
                                maxHeight: 'calc(100dvh - 180px)',
                                overflow: 'auto',
                                padding: '12px',
                                backgroundColor: '#fff',
                                borderRadius: '4px',
                            },
                            '& .doc-preview table': {
                                borderCollapse: 'collapse',
                                width: '100%',
                            },
                            '& .doc-preview td, & .doc-preview th': {
                                border: '1px solid #ddd',
                                padding: '6px',
                            }
                        } }, previewType === 'image' ? (React.createElement(Box, { sx: {
                            overflow: 'auto',
                            overflowX: zoomPercentage > 100 ? 'auto' : 'hidden',
                        } },
                        React.createElement(Box, { component: "img", src: fileUrl !== null && fileUrl !== void 0 ? fileUrl : undefined, alt: "File Preview", className: 'image-preview', sx: __assign(__assign({}, getZoomStyles('top center')), { minWidth: zoomedMinWidth }) }))) : previewType === 'docx' || previewType === 'xlsx' || previewType === 'text' ? (React.createElement(Box, { sx: {
                            overflow: 'auto',
                            overflowX: zoomPercentage > 100 ? 'auto' : 'hidden',
                        } },
                        React.createElement(Box, { className: 'doc-preview', sx: __assign(__assign({}, getZoomStyles('top left')), { minWidth: zoomedMinWidth }), dangerouslySetInnerHTML: { __html: previewHtml !== null && previewHtml !== void 0 ? previewHtml : '<p>Preview not available.</p>' } }))) : previewType === 'html' ? (React.createElement(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'calc(100dvh - 126px)',
                        } },
                        React.createElement(Box, { sx: {
                                flex: 1,
                                minHeight: 0,
                                overflow: 'auto',
                                overflowX: 'auto',
                                backgroundColor: '#fff',
                            } },
                            React.createElement(Box, { component: "iframe", srcDoc: previewHtml, title: titleText, sandbox: "allow-popups", sx: __assign(__assign({}, getZoomStyles('top left')), { width: zoomedMinWidth, minWidth: zoomedMinWidth, border: 'none', height: '100%' }) })),
                        attachments && attachments.length > 0 && (React.createElement(Box, { sx: {
                                flexShrink: 0,
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 1,
                                p: 1.5,
                                borderTop: '1px solid #E5E7EB',
                                backgroundColor: '#fff',
                            } }, attachments.map(function (attachment, attachmentIndex) { return (React.createElement(Box, { key: "".concat(attachment.filename, "-").concat(attachmentIndex), component: "button", type: "button", onClick: function () { return openEmlAttachment(attachment); }, sx: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 0.75,
                                px: 1.25,
                                py: 0.75,
                                border: '1px solid #D1D5DB',
                                borderRadius: '6px',
                                backgroundColor: '#F9FAFB',
                                color: '#1F2937',
                                fontSize: 12,
                                fontFamily: 'inherit',
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#F3F4F6' },
                            } },
                            "\uD83D\uDCCE ",
                            attachment.filename,
                            React.createElement(Typography, { component: "span", sx: { fontSize: 11, color: '#9CA3AF' } },
                                "(",
                                attachment.sizeLabel,
                                ")"))); }))))) : (React.createElement(Box, { sx: {
                            overflow: 'auto',
                            overflowX: zoomPercentage > 100 ? 'auto' : 'hidden',
                        } },
                        React.createElement(Box, { component: "iframe", src: fileUrl !== null && fileUrl !== void 0 ? fileUrl : undefined, title: "PDF Preview", sx: __assign(__assign({}, getZoomStyles('top left')), { width: zoomedMinWidth, minWidth: zoomedMinWidth, border: 'none', height: 'calc(100dvh - 126px)' }) })))))));
        }
        case POPUP_TYPE.EVENT_NOT_ALLOWED: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title' },
                    React.createElement(Box, { className: 'dialogue-text' },
                        React.createElement(IconButton, { className: 'error-icon' },
                            " ",
                            React.createElement(ErrorIcon, null)),
                        React.createElement(Typography, null, titleText))),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText))));
        }
        case POPUP_TYPE.SUCCESS_ALERT: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title sucess-title' },
                    React.createElement(IconButton, { className: 'success-icon' },
                        " ",
                        React.createElement(CheckCircleIcon, null)),
                    React.createElement(Typography, null, titleText)),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
                React.createElement(DialogActions, null,
                    denyBtnText && (React.createElement(Button, { variant: 'outlined', size: 'small', className: 'btn-txt btn-small', onClick: function () { return denyCallBack && denyCallBack(); } }, denyBtnText)),
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText))));
        }
        case POPUP_TYPE.DELETE_CONFIRMATION_WARNING: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title', sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                    React.createElement(Box, { className: 'dialogue-text', sx: { display: 'flex', alignItems: 'center', gap: 1 } },
                        React.createElement(IconButton, { className: 'error-icon', sx: { p: 0 } },
                            " ",
                            React.createElement(ErrorIcon, null)),
                        React.createElement(Typography, null, titleText)),
                    React.createElement(Box, null,
                        React.createElement(IconButton, { className: 'warning-icon', onClick: function () { return cancelCallBack && cancelCallBack(); }, sx: { p: 0 } },
                            " ",
                            React.createElement(CloseFileCardIcon, null)))),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
                React.createElement(DialogActions, null, swapButtonOrder ? (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: 'outlined', size: 'small', className: 'btn-txt', onClick: function () { return denyCallBack && denyCallBack(); } }, denyBtnText),
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText))) : (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: 'outlined', size: 'small', className: 'btn-txt', onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText),
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', onClick: function () { return denyCallBack && denyCallBack(); } }, denyBtnText))))));
        }
        case POPUP_TYPE.UNSAVED_DATA_WARNING:
        case POPUP_TYPE.LOGOUT_WARNING: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title' },
                    React.createElement(Box, { className: 'dialogue-text' },
                        React.createElement(IconButton, { className: 'warning-icon' },
                            " ",
                            React.createElement(WarningIcon, null)),
                        React.createElement(Typography, null, titleText)),
                    React.createElement(Box, null,
                        React.createElement(IconButton, { className: 'warning-icon', onClick: function () { return cancelCallBack && cancelCallBack(); } },
                            React.createElement(CloseFileCardIcon, null)))),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { variant: 'outlined', size: 'small', className: 'btn-txt btn-small', sx: equalWidthActions ? WARNING_ACTION_BUTTON_SX : undefined, onClick: function () { return denyCallBack && denyCallBack(); } }, denyBtnText),
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', sx: equalWidthActions ? WARNING_FILLED_BUTTON_SX : undefined, onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText))));
        }
        case POPUP_TYPE.RELOAD: {
            return (React.createElement(Dialog, { "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", open: open, className: 'alert-popwindow' },
                React.createElement(DialogTitle, { id: "alert-dialog-title", className: 'dialogue-title sucess-title' },
                    React.createElement(IconButton, { className: 'success-icon' },
                        " ",
                        React.createElement(CachedIcon, null)),
                    React.createElement(Typography, null, titleText)),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, { id: "alert-dialog-description" }, message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { variant: 'contained', size: 'small', className: 'btn-txt', onClick: function () { return acceptCallBack && acceptCallBack(); } }, acceptBtnText))));
        }
        default: {
            return React.createElement(React.Fragment, null);
        }
    }
};
export default memo(ConfirmationAndInformationPoup);
